cobalt-notification-pill {
  display: inline-flex;
}
